import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";

export default function MusicChartRow({ item, virtualizer, virtualRow, setCatalogueSong, showDetailedSpins = false, showFirstOn = false }) {
    const { competitorRadios } = useRouteLoaderData("root");

    return (
        <Row
            data-index={virtualRow?.index}
            ref={virtualizer.measureElement}
            style={{ transform: `translateY(${virtualRow?.start - virtualizer?.options.scrollMargin}px)` }}
            className={`py-1 border-bottom  position-absolute w-100 hoverable`}
            onClick={() => setCatalogueSong(item)}>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.artist}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.title}
            </Col>
            <Col xs={2} xl={showDetailedSpins ? 1 : 2} className=" align-content-center text-center d-none d-xl-block">
                {item.release_year}
            </Col>
            <Col xs={12} className=" align-content-center d-xl-none">
                <Row className="gx-1">
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.artist}</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">-</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.title}</span>
                    </Col>
                    {item.release_year && (
                        <Col xs={"auto"}>
                            <span className="fw-bold fw-xl-normal">({item.release_year})</span>
                        </Col>
                    )}
                </Row>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                <span className=" d-xl-none">Spins: </span>
                <span className=" fw-bold fw-xl-normal">{item.spins}</span>
            </Col>
            {showDetailedSpins && (
                <>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">18-06: </span>
                        <span className=" fw-bold fw-xl-normal">{item.spins_18_6}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">06-10: </span>
                        <span className=" fw-bold fw-xl-normal">{item.spins_6_10}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">10-14: </span>
                        <span className=" fw-bold fw-xl-normal">{item.spins_10_14}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">14-18: </span>
                        <span className=" fw-bold fw-xl-normal">{item.spins_14_18}</span>
                    </Col>
                </>
            )}
            {showDetailedSpins && <Col xs={12} className="d-xl-none"></Col>}
            <Col xs={"auto"} xl={showDetailedSpins ? 1 : 2} className=" align-content-center text-center px-xl-1">
                <span className=" d-xl-none">First played: </span>
                <span className=" fw-bold fw-xl-normal">{moment(item.first_play).format("L HH:mm")}</span>
            </Col>
            {showFirstOn && (
                <>
                    <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                        <span className=" d-xl-none">First on: </span>
                        <Suspense>
                            <Await resolve={competitorRadios}>
                                {resolvedCompetitorRadios => (
                                    <span className=" fw-bold fw-xl-normal">
                                        {resolvedCompetitorRadios.data.find(x => x.radio_id === item.first_on)?.radio_name}
                                    </span>
                                )}
                            </Await>
                        </Suspense>
                    </Col>
                </>
            )}
        </Row>
    );
}
